import * as api from '../api';
import { actionTypes } from 'redux-resource';
import { SubmissionError } from 'redux-form';

export const findSqlReportQuery = (id) => (dispatch) => {
  const actionDefaults = {
    resourceType: 'sqlReportQueries',
    requestKey: 'findSqlReportQuery',
    resources: [id],
  };

  dispatch({
    ...actionDefaults,
    type: actionTypes.READ_RESOURCES_PENDING,
  });

  return api
    .findSqlReportQuery(id)
    .then((response) => {
      dispatch({
        ...actionDefaults,
        type: actionTypes.READ_RESOURCES_SUCCEEDED,
        resources: [response.data],
      });
    })
    .catch((err) => {
      dispatch({
        ...actionDefaults,
        type: actionTypes.READ_RESOURCES_FAILED,
        statusCode: err.response && err.response.status,
      });
    });
};

export const updateSqlReportQuery = (id, attrs) => (dispatch) => {
  const actionDefaults = {
    resourceType: 'sqlReportQueries',
    requestKey: 'updateSqlReportQuery',
    resources: [id],
  };

  dispatch({
    ...actionDefaults,
    type: actionTypes.UPDATE_RESOURCES_PENDING,
  });

  return api
    .updateSqlReportQuery(id, attrs)
    .then((response) => {
      dispatch({
        ...actionDefaults,
        type: actionTypes.UPDATE_RESOURCES_SUCCEEDED,
        resources: [response.data],
      });
    })
    .catch((err) => {
      dispatch({
        ...actionDefaults,
        type: actionTypes.UPDATE_RESOURCES_FAILED,
      });
      let messages = err.response
        ? err.response.data
        : { detail: 'Something went wrong' };
      if (messages.detail) {
        throw new SubmissionError({ _error: messages });
      } else if (messages.message || messages.error) {
        throw new SubmissionError({
          _error: messages.message || messages.error,
        });
      } else {
        throw new SubmissionError(messages);
      }
    });
};
